var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsTabs',_vm._b({attrs:{"value":_vm.tab},on:{"update:value":function($event){_vm.tab=$event}},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c(item.is,_vm._b({tag:"component"},'component',{
                loading: _vm.loading,
                entity: _vm.entity
            },false))]}}])},'EqsTabs',{ tabs: _vm.tabs, color: 'transparent' },false))
}
var staticRenderFns = []

export { render, staticRenderFns }